import { render } from "./WNrestartRecordListCY.vue?vue&type=template&id=cc20df6e&scoped=true"
import script from "./WNrestartRecordListCY.vue?vue&type=script&lang=js"
export * from "./WNrestartRecordListCY.vue?vue&type=script&lang=js"

import "./WNrestartRecordListCY.vue?vue&type=style&index=0&id=cc20df6e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cc20df6e"

export default script